import useAxios from "axios-hooks";
import { useEffect, useState } from "react";
import { Resource } from "../../../../api/common";
import { Button, Col, Dropdown, Menu, Row } from "antd";
import { useTranslation } from "react-i18next";
import React from "react";
import { OrderDetailsModal } from "./OrderDetailsModal";
import { RequestComments } from "./Drawer/RequestComments";
import { EllipsisOutlined } from "@ant-design/icons";

const OrderListSeller = (props: any) => {
   const { data, getData } = props;
   const [t] = useTranslation();
   const [requestData, setRequestData] = useState<any>();
   const [allRequests, setallRequests] = useState<any>([]);
   const [showOrderDetails, setShowOrderDetails] = useState(false);
   const [showRequestComments, setShowRequestComments] = useState(false);

   useEffect(() => {
      setRequestData(data.requestData[0]);
      setallRequests(data.requestData);
   }, [data]);

   const [{ loading: updateOrderLoading }, updateOrder] = useAxios(
      {
         url: `${Resource.path.updateOrderApi(data.id)}`,
         method: "POST"
      },
      { manual: true }
   );

   const showOrderStatusLabel = (status: any) => {
      switch (status) {
         case "REQUESTED":
         case "AVAILABLE":
            return (
               <span className="status-tag requested">
                  {t("demands.requested")}
               </span>
            );
         case "ACCEPTED":
            return (
               <span className="status-tag accepted">
                  {t("demands.accepted")}
               </span>
            );
         case "IN-PROGRESS":
            return (
               <span className="status-tag ordered">
                  {t("demands.ordered")}
               </span>
            );
         case "ORDERED":
            return (
               <span className="status-tag ordered">
                  {t("demands.ordered")}
               </span>
            );
         case "DELIVERED":
            return (
               <span className="status-tag closed">{t("demands.closed")}</span>
            );
         case "FAILED":
         case "DECLINED":
            return (
               <span className="status-tag cancelled">
                  {t("demands.cancelled")}
               </span>
            );
      }
   };

   const totalPieces = () => {
      return allRequests
         ? allRequests
              .reduce(
                 (a: any, b: { [x: string]: any }) => a + (+b["amount"] || 0),
                 0
              )
              .toLocaleString()
         : 0;
   };

   const reqestItemMenu = (
      <Menu className="more-menu">
         <Menu.Item
            key="2"
            disabled={data.status != "REQUESTED"}
            onClick={async () => {
               await updateOrder({
                  data: {
                     status: "DECLINED"
                  }
               });
               await getData();
            }}
         >
            {t("demands.cancelOrder")}
         </Menu.Item>
      </Menu>
   );

   const acceptOrder = async () => {
      await updateOrder({
         data: {
            status: "ORDERED"
         }
      });
      await getData();
   };

   const closeOrder = async () => {
      await updateOrder({
         data: {
            status: "DELIVERED"
         }
      });
      await getData();
   };

   if (updateOrderLoading) {
      (window as any).NProgress.start();
   } else {
      (window as any).NProgress.done();
   }

   return (
      <>
         <Row className="order-wrapper inner sourcing">
            <Col span={8}>
               <div
                  className="hover-state"
                  onClick={() => {
                     setShowOrderDetails(true);
                  }}
               >
                  <div className="order-status-label">
                     {showOrderStatusLabel(data.status)}
                  </div>
                  <div className="item-info">
                     <figure className="">
                        {requestData?.images.length ? (
                           <img src={requestData?.images[0]?.object_url} />
                        ) : (
                           <img src="data:image/png;base64,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" />
                        )}
                     </figure>
                     <div className="order-title">
                        <strong>{`${requestData?.product_name}`}</strong>
                        <span className="amount">
                           {totalPieces()}{" "}
                           {t(
                              requestData?.amount_unit == "Stück"
                                 ? t("demands.pieces")
                                 : requestData?.amount_unit
                           )}
                        </span>
                     </div>
                  </div>
               </div>
            </Col>
            <Col span={16}>
               <div className="last-col">
                  {data.status === "REQUESTED" && (
                     <div className="actions">
                        <div className="order">
                           <Button
                              className="shadow-button"
                              type="primary"
                              onClick={acceptOrder}
                           >
                              {t("default.accept").toLocaleLowerCase()}
                           </Button>
                        </div>
                        <Button
                           type="default"
                           className="shadow-button"
                           onClick={() => {
                              setShowRequestComments(true);
                           }}
                        >
                           chat
                        </Button>
                     </div>
                  )}
                  {(data.status == "ACCEPTED" || data.status == "ORDERED") &&
                     data.status !== "REQUESTED" && (
                        <div className="actions">
                           {data.status !== "DECLINED" &&
                              data.status !== "FAILED" &&
                              data.status !== "DELIVERED" && (
                                 <div className="order">
                                    <Button
                                       className="shadow-button"
                                       type="primary"
                                       onClick={closeOrder}
                                    >
                                       {t("default.close").toLocaleLowerCase()}
                                    </Button>
                                 </div>
                              )}
                           <Button
                              type="default"
                              className="shadow-button"
                              onClick={() => {
                                 setShowRequestComments(true);
                              }}
                           >
                              chat
                           </Button>
                        </div>
                     )}
                  {!!showRequestComments && (
                     <RequestComments
                        data={data}
                        visible={showRequestComments}
                        onClose={() => {
                           setShowRequestComments(!showRequestComments);
                        }}
                        created_by_type="SELLER"
                     />
                  )}
                  <div style={{ position: "relative", height: "30px" }}>
                     <Dropdown
                        overlay={reqestItemMenu}
                        placement="topLeft"
                        trigger={["click"]}
                     >
                        <Button
                           className="more-button"
                           type="link"
                           icon={
                              <EllipsisOutlined style={{ fontSize: "25px" }} />
                           }
                        ></Button>
                     </Dropdown>
                  </div>
               </div>
            </Col>
         </Row>
         {showOrderDetails && (
            <OrderDetailsModal
               visible={showOrderDetails}
               onCancel={() => setShowOrderDetails(false)}
               requestData={requestData}
               seller
            />
         )}
      </>
   );
};

export default OrderListSeller;
